export const IP_COUNTRY_COOKIE_NAME = 'ipCountry';
export const AUTOMATIC_REDIRECTION_COOKIE_NAME = 'redirectionStoreSelected';
